<script lang="ts">
  import { AlertTriangle, Info, X } from "svelte-feathers"

  export let type: "info" | "error"
  export let title: string | undefined
  export let body: string
  export let actionText = "OK"
  export let actionHref: string | undefined
  export let actionTarget: string | undefined

  let visible = true

  function hide() {
    visible = false
    if (history?.state?.flash) {
      history.replaceState(null, null)
    }
  }
</script>

{#if visible}
  <div
    class="
      notice {type}
      switcher threshold-160 align-center justify-between gap-5 pad-5
      inline-full z-50 block-start-16 inline-end-0 sm:absolute sm:block-start-3 sm:inline-end-3 sm:inline-120
      bg-lightest fg-dark border-0 sm:border-dark-20 shadow--sm radius-0 sm:radius-2
      weight-400"
    role="dialog">
    <div class="row split-last align-center gap-3">
      <div class="below-sm:hidden">
        {#if type == "info"}
          <Info size="20" />
        {/if}

        {#if type == "error"}
          <AlertTriangle size="20" />
        {/if}
      </div>

      <div data-role="{type}-notice">
        {#if title}
          <h3 class="fg-dark">{title}</h3>
        {/if}
        <div>{body}</div>
      </div>

      <button
        aria-label="Close"
        class="relative inline-start-3 bg-lightest hover:bg-light hover:fg-dark fg-dark"
        on:click={hide}>
        <X size="20" />
      </button>
    </div>

    {#if actionHref}
      <a
        href={actionHref}
        target={actionTarget || "_self"}
        class="
          center-contents
          grow-0 min-inline-40 min-block-11
          bg-lightest fg-dark hover:fg-dark hover:border-dark hover:bg-light radius-1 border-dark bg-inherit
          weight-400 hover:no-line">
        {actionText}
      </a>
    {/if}
  </div>
{/if}

<style lang="postcss">
  /*
    The dialog element is not supported in Safari 15.3.
    Apparently, it has other issues too.
    Let's use a div for now and reassess in Q2 2023
  */
  :global(.notice.error) {
    --color-lightest: var(--color-red-50);
    --color-light: var(--color-red-100);
    --color-dark: var(--color-red-700);
    --border-dark: solid 1px var(--color-red-700);
  }

  :global(.notice.info) {
    --color-lightest: white;
    --color-light: var(--color-gray-100);
    --color-dark: var(--color-gray-900);
    --border-dark: solid 1px var(--color-gray-900);
  }

  .notice :global(svg) {
    flex-shrink: 0;
    stroke-width: 1.5px;
  }
</style>
